export const MAP_GEOFENCES_CONTACTS_OPEN_MODAL = "MAP_GEOFENCES_CONTACTS_OPEN_MODAL";
export const MAP_GEOFENCES_CONTACTS_GET_GEOFENCE = "MAP_GEOFENCES_CONTACTS_GET_GEOFENCE";
export const MAP_GEOFENCES_CONTACTS_GET_GEOFENCE_RESPONSE = "MAP_GEOFENCES_CONTACTS_GET_GEOFENCE_RESPONSE"
export const MAP_GEOFENCES_CONTACTS_SAVE = "MAP_GEOFENCES_CONTACTS_SAVE";
export const MAP_GEOFENCES_CONTACTS_SAVE_RESPONSE = "MAP_GEOFENCES_CONTACTS_SAVE_RESPONSE";